/** Ref-counted `document.body` scroll lock for CADS modals. */

let _lockCount = 0;
let _savedOverflow = '';

/**
 * Locks page scroll by setting `document.body.style.overflow = 'hidden'`.
 * Returns an unlock function; safe to call multiple times (ref-counted).
 */
export function lockBodyScroll(): () => void {
  if (typeof document === 'undefined') {
    return () => undefined;
  }
  if (_lockCount === 0) {
    _savedOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
  }
  _lockCount++;
  return () => {
    unlockBodyScroll();
  };
}

/** Decrements the lock ref-count and restores overflow when the last lock is released. */
export function unlockBodyScroll(): void {
  if (typeof document === 'undefined' || _lockCount <= 0) {
    return;
  }
  _lockCount--;
  if (_lockCount === 0) {
    document.body.style.overflow = _savedOverflow;
    _savedOverflow = '';
  }
}

/** Clears all locks and restores the overflow captured on the first lock (safety net on modal close / navigation). */
export function forceUnlockBodyScroll(): void {
  if (typeof document === 'undefined') {
    _lockCount = 0;
    _savedOverflow = '';
    return;
  }
  if (_lockCount > 0) {
    document.body.style.overflow = _savedOverflow;
  }
  _lockCount = 0;
  _savedOverflow = '';
}

/** Resets lock state between tests. */
export function resetBodyScrollLockForTesting(): void {
  _lockCount = 0;
  _savedOverflow = '';
}
